import React from 'react';
import i18n from './I18next';

/*

In every es class you need the following import
import I18 from '../shared/I18';


JSON:
"test":"{{count}} Passagier (Singular)",
"test_plural":"{{count}} Passagiere (Plural)",
"testword":"Var A : {{vara}} Var B : {{varb}} Var C : {{varc}}"

<I18 textkey="test" count="0"/> -> 0 Passagiere (Plural)
<I18 textkey="test" count="1"/> -> 1 Passagier (Singular)
<I18 textkey="test" count="2"/> -> 2 Passagiere (Plural)
<I18 textkey="testword" named={{"vara":"aaaaa","varb":"bbbb","varc":"ccccc"}}/> -> Var A : aaaaa Var B : bbbb Var C : ccccc

*/


export default class I18Element extends React.Component {
    constructor(props) {
        super(props);

        const divStyle = {
            fontSize : '.8em',
            color: 'red'
        };

        this.state = {
            key:"",
            type:"",
            value:"",
            defValue:"",
            debug:false,
            style:divStyle
        };
    }
    static t(key){
        return t(key, null, null, null)
    }
    static t(key, defaultvalue){
        return t(key, defaultvalue, null, null)
    }
    static t(key, defaultvalue, count){
        return t(key, defaultvalue, count, null)
    }

    static t(key, defaultvalue, count, named){

        let ret;

        if( key && !defaultvalue && !count & !named){
            ret = i18n.t(key, "")
        }
        else if( key && defaultvalue && !count & !named){
            ret = i18n.t(key,defaultvalue)
        }
        else if( key && defaultvalue && count){
            if(i18n.options.debug) {
                console.log("Key : "+key + "   /   Count : " +count)
            }
            const num = parseInt(count)
            ret = i18n.t(key, { count: num });
        }
        else if( key && defaultvalue && named){
            ret = i18n.t(key, named )
        }

        if(i18n.options.debug) {
            ret = "I18 : "+ret
        }

        return ret;
    }
    componentWillMount(){
        let ret;
        if(this.props.count) {
            ret = i18n.t(this.props.textkey, { count: parseInt(this.props.count) })
        }
        else if (this.props.named){
            ret = i18n.t(this.props.textkey, this.props.named )
        }
        else
            ret = i18n.t(this.props.textkey,this.props.defaultValue)

        if(i18n.options.debug) {
            this.setState({debug:i18n.options.debug});
        }
        if(i18n.options.debug) {
            ret = "I18 : "+ret
        }
        this.setState({
            key:this.props.textkey,
            value:ret,
            defValue:this.props.defaultValue
        })
    }

    render() {
        if(this.state.debug){
            return <span><span>{this.state.value}</span><br/><span style={this.state.style}>{this.state.key}</span><br/></span>
        }
        else {
            return (<span>{this.state.value}</span>)
        }
    }
}



// WEBPACK FOOTER //
// ./shared/I18.jsx